export function setupSkeletonCountObserver(
  containerRef: React.RefObject<HTMLDivElement | null>,
  rowRef: React.RefObject<HTMLDivElement | null>,
  setSkeletonCount: (count: number) => void,
  defaultCount = 5,
) {
  const calculateSkeletonCount = () => {
    const container = containerRef.current?.parentElement
    const row = rowRef.current
    if (!container || !row) return

    const containerHeight = container.clientHeight
    const rowHeight = row.clientHeight

    if (containerHeight && rowHeight) {
      const count = Math.ceil(containerHeight / rowHeight)
      setSkeletonCount(count > 0 ? count : defaultCount)
    }
  }

  calculateSkeletonCount()
  const resizeObserver = new ResizeObserver(calculateSkeletonCount)

  if (containerRef.current?.parentElement) {
    resizeObserver.observe(containerRef.current.parentElement)
  }

  return () => {
    resizeObserver.disconnect()
  }
}
